import React, { ReactNode } from 'react';

import { CounterLabel, Text, IconButton } from "@primer/react";
import { Stack } from "@primer/react/experimental";
import { XIcon } from '@primer/octicons-react'

interface TableActionsBannerProps {
    count: number | undefined;
    title: string
    buttons: ReactNode[];
    onDismiss: () => void;
    didDismiss: () => void;
}

const TableActionsBanner: React.FC<TableActionsBannerProps> = ({ count, title, buttons, onDismiss, didDismiss }) => {

    return (
        <div className="h-[52px] bg-white border border-border rounded-md floating-toast inline-flex items-center">
            <div className='flex items-center'>
                <Stack align="center" direction="horizontal" className='ml-4 mr-2' gap={'none'}>
                    {count && <CounterLabel scheme="primary">{count}</CounterLabel>}
                    <Text size="medium" className='ml-2 mr-[10px] whitespace-nowrap'>{title}</Text>
                    {buttons.map((button, index) => {
                        return <div key={index} className='ml-1 mr-1'>{button}</div>;
                    })}
                    <IconButton
                        onClick={() => {
                            onDismiss();
                            didDismiss();
                        }}
                        icon={XIcon}
                        variant="invisible"
                        aria-label="Закрыть"
                        className='ml-[10px]' />
                </Stack>
            </div>
        </div>
    );
};

export default TableActionsBanner;